import instanciaAxios from './InterceptorAxios';

const servicioEnvioCorreo = {
	envioCorreo(correo) {
		return instanciaAxios.post('correo/envio.json',correo);
	}
}

export default servicioEnvioCorreo;